import { z } from 'zod/v4';
import { createDefinitionSchema } from '../utils/helpers';

export const timelineEventQueryDefinitionSchema = createDefinitionSchema(
  'TimelineEventQuery',
  z.object({
    query: z.string(),
  })
);

export const changeEventsDataQueryDefinitionSchema = createDefinitionSchema(
  'ChangeEventsDataQuery',
  z.object({
    query: z.string(),
    group_by: z.string().optional().describe('Determines how the events are grouped'),
  })
);

export type TimelineEventQueryDefinition = z.infer<typeof timelineEventQueryDefinitionSchema>;
export type ChangeEventsDataQueryDefinition = z.infer<typeof changeEventsDataQueryDefinitionSchema>;
